import { render, staticRenderFns } from "./ServiceProviderLogs.vue?vue&type=template&id=4f2fdb80"
import script from "./ServiceProviderLogs.vue?vue&type=script&lang=js"
export * from "./ServiceProviderLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports